module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-02.06fdebea.svg";